import React from "react";
import "./Tabs.css";

/**
 * Filter tabs — horizontal strip with optional count badges and a teal active
 * underline. Surface-aware.
 *
 * Props:
 *   items:    [{ value, label, count? }]
 *   value:    active value
 *   onChange: (value) => void
 */
const Tabs = ({ items = [], value, onChange, className = "" }) => (
  <div className={`gx-tabs ${className}`} role="tablist">
    {items.map((item) => {
      const active = item.value === value;
      return (
        <button
          key={item.value}
          role="tab"
          aria-selected={active}
          className={`gx-tab ${active ? "is-active" : ""}`}
          onClick={() => onChange && onChange(item.value)}
        >
          {item.label}
          {item.count != null && <span className="gx-tab-count">{item.count}</span>}
        </button>
      );
    })}
  </div>
);

export default Tabs;
